import React from 'react'
export interface DonationCardProps {
  image: string
  imageAlt: string
  title: string
  description: string
  callout: string
  className?: string
  'data-id'?: string
}
export const DonationCard = ({
  image,
  imageAlt,
  title,
  description,
  callout,
  className = '',
  'data-id': dataId,
}: DonationCardProps) => {
  return (
    <article
      data-id={dataId}
      className={`w-full bg-[#181818] p-8 md:p-12 lg:p-16 ${className}`}
    >
      <div className="max-w-6xl mx-auto">
        <div className="relative">
          {' '}
          {/* Image Section */}
          <div className="w-full lg:w-[70%] h-[400px] md:h-[500px] lg:h-[600px]">
            <img
              src={image}
              alt={imageAlt}
              className="w-full h-full object-cover"
            />
          </div>
          {/* Text Card Section - Overlapping */}
          <div className="relative lg:absolute lg:top-1/2 lg:-translate-y-1/2 lg:right-0 lg:w-[45%] mt-6 lg:mt-0">
            <div className="bg-white rounded-none shadow-xl p-6 md:p-8">
              <h1 className="text-2xl md:text-3xl font-bold text-red-700 mb-4">
                {title}
              </h1>
              <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-3">
                {description}
              </p>
              <p className="text-gray-900 font-bold text-base md:text-lg">
                {callout}
              </p>
            </div>
          </div>
        </div>
      </div>
    </article>
  )
}